// extracted by css-extract-rspack-plugin
export default {"Box_0":"BlankState-module__Box_0__igrkG","Box_1":"BlankState-module__Box_1__bYgv2","Box_2":"BlankState-module__Box_2__AwWdR","Box_3":"BlankState-module__Box_3__QL0jO"};